/* =====================================================================
   SDN EFFECTS LAYER  ·  modular visual upgrade for the Bullet theme
   ---------------------------------------------------------------------
   - Loaded only when Theme settings → "SDN Visual Effects" is ON.
   - Everything is namespaced; the kill-switch is the `sdn-fx` body class
     (added in layout/theme.liquid). Remove that class or disable the
     setting to fully restore the original behaviour.
   - Effects are added step by step. STEP 1 = scaffold + card hover (CSS).
     Later steps (reveals, grain, marquee) plug into the hooks below.
   ===================================================================== */
(function () {
  'use strict';

  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Reflect the user's motion preference on <body> so CSS can react. */
  function applyMotionPref() {
    document.body.classList.toggle('sdn-reduced-motion', reduceMQ.matches);
  }

  /* STEP 3: inject the film-grain overlay layer (styled in sdn-effects.css,
     only visible while <body> has the `sdn-fx` class). */
  function ensureGrain() {
    if (document.getElementById('sdn-grain')) return;
    var g = document.createElement('div');
    g.id = 'sdn-grain';
    g.setAttribute('aria-hidden', 'true');
    document.body.appendChild(g);
  }

  /* PRODUCT GALLERY (desktop editorial layout):
     the layout itself is CSS (sdn-product.css). Here we only make the small
     thumbnails clickable: clicking a non-active slide promotes it to the main
     image via the theme's own media-gallery.setActiveMedia(). The active slide
     still opens the zoom (photoswipe) as before. */
  function initProductGallery(scope) {
    var galleries = (scope || document).querySelectorAll('.product-page media-gallery');

    galleries.forEach(function (gallery) {
      if (gallery.dataset.sdnGallery === '1') return;
      gallery.dataset.sdnGallery = '1';

      var viewer = gallery.querySelector('slider-component');
      if (!viewer) return;
      var mainWrap = viewer.querySelector('[id^="Slider-Gallery"]');
      if (!mainWrap) return;

      function slides() {
        return Array.prototype.slice.call(mainWrap.querySelectorAll('.slider__slide'));
      }

      /* which half of the active image is the pointer on? (-1 = left, +1 = right) */
      function side(e) {
        var active = mainWrap.querySelector('.slider__slide.is-active');
        var img = (active && active.querySelector('img')) || active || mainWrap;
        var r = img.getBoundingClientRect();
        return (e.clientX - r.left) > r.width / 2 ? 1 : -1;
      }

      /* go to next (+1) or previous (-1) image, wrapping around */
      function go(dir) {
        var arr = slides();
        if (arr.length < 2) return;
        var idx = 0;
        arr.forEach(function (s, i) { if (s.classList.contains('is-active')) idx = i; });
        var next = (idx + dir + arr.length) % arr.length;
        var id = arr[next].getAttribute('data-media-id');
        if (id && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(id, false);
      }

      /* gallery click/tap navigation is active from 778px up (tablet + desktop);
         below that the theme's native swipe gallery is used. */
      var desktop = function () { return window.matchMedia('(min-width: 778px)').matches; };

      /* directional arrow cursor over the product image (left half = back, right = next) */
      mainWrap.addEventListener('mousemove', function (e) {
        var active = e.target.closest('.slider__slide.is-active');
        if (!desktop() || !active || slides().length < 2) {
          mainWrap.classList.remove('sdn-nav-right', 'sdn-nav-left');
          return;
        }
        var right = side(e) > 0;
        mainWrap.classList.toggle('sdn-nav-right', right);
        mainWrap.classList.toggle('sdn-nav-left', !right);
      });
      mainWrap.addEventListener('mouseleave', function () {
        mainWrap.classList.remove('sdn-nav-right', 'sdn-nav-left');
      });

      /* click the product image -> previous / next (capture phase beats the zoom anchor).
         Desktop only — mobile keeps the theme's native swipe gallery. */
      mainWrap.addEventListener('click', function (e) {
        if (!desktop()) return;
        var active = e.target.closest('.slider__slide.is-active');
        if (!active) return;
        e.preventDefault();
        e.stopPropagation();
        go(side(e));
      }, true);
    });
  }

  /* PRODUCT BUY-BOX: turn SIZING / MATERIALS (and a fixed SHIPPING note) into a
     horizontal button row + one shared panel (accordion, only one open). */
  function initProductAccordion(scope) {
    var pcs = (scope || document).querySelectorAll('.product-page .bullet-product-content product-content');
    pcs.forEach(function (pc) {
      if (pc.dataset.sdnAcc === '1') return;
      pc.dataset.sdnAcc = '1';

      var desc = pc.querySelector('.description');
      var existing = desc ? Array.prototype.slice.call(desc.querySelectorAll('.pd-acc details')) : [];

      var items = [{
        label: 'SHIPPING',
        html: '<p>Shipping will start 1–3 working days after purchase.<br>We ship out every Wednesday and Friday.</p>'
      }];
      /* DOM order is SIZING then MATERIALS; reverse -> MATERIAL, SIZING (matches the design) */
      existing.reverse().forEach(function (d) {
        var sumSpan = d.querySelector('summary span') || d.querySelector('summary');
        var label = (sumSpan ? sumSpan.textContent : '').trim();
        var c = d.querySelector('.pd-acc-content');
        items.push({ label: label, html: c ? c.innerHTML : '' });
        var holder = d.closest('.pd-acc');
        if (holder) holder.style.display = 'none';   /* hide the original accordion */
      });

      var wrap = document.createElement('div'); wrap.className = 'sdn-acc';
      var tabs = document.createElement('div'); tabs.className = 'sdn-acc-tabs';
      var panel = document.createElement('div'); panel.className = 'sdn-acc-panel';

      items.forEach(function (it) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sdn-acc-tab';
        b.textContent = it.label || 'INFO';
        b.addEventListener('click', function () {
          var wasOpen = b.classList.contains('is-open');
          tabs.querySelectorAll('.sdn-acc-tab').forEach(function (x) { x.classList.remove('is-open'); });
          if (wasOpen) {
            panel.hidden = true;
            panel.innerHTML = '';
          } else {
            b.classList.add('is-open');
            panel.innerHTML = it.html;
            panel.hidden = false;
          }
        });
        tabs.appendChild(b);
      });

      wrap.appendChild(tabs);
      wrap.appendChild(panel);
      /* open SHIPPING by default */
      panel.innerHTML = items[0].html;
      panel.hidden = false;
      if (tabs.firstChild) tabs.firstChild.classList.add('is-open');

      (desc || pc).appendChild(wrap);

      /* avoid duplication: hide any pre-existing static shipping note
         (the same text now lives in the SHIPPING panel). Conservative:
         only small elements that literally contain the shipping phrase. */
      pc.querySelectorAll('p, small, div, span').forEach(function (el) {
        if (el.closest('.sdn-acc')) return;
        var t = (el.textContent || '').toLowerCase();
        if (t.indexOf('working days after purchase') !== -1 && el.children.length <= 2 && t.length < 220) {
          el.style.display = 'none';
        }
      });
    });
  }

  /* PRODUCT INFO SPLIT: move the title + price into a right-hand column
     (vertically centred), leaving the size/buy/accordion block on the left.
     Desktop only; on mobile everything stays in its original place. */
  function initProductInfoSplit(scope) {
    /* title + price move to the right column only in the 3-column desktop layout */
    var mql = window.matchMedia('(min-width: 1100px)');
    var pages = (scope || document).querySelectorAll('.product-page');

    pages.forEach(function (pg) {
      if (pg.dataset.sdnInfo === '1') return;
      pg.dataset.sdnInfo = '1';

      var grid = pg.querySelector('x-grid');
      var content = pg.querySelector('.bullet-product-content');
      if (!grid || !content) return;

      var title = content.querySelector('.title');
      var price = content.querySelector('section[id^="price-"]');
      if (!title && !price) return;

      var info = document.createElement('div');
      info.className = 'sdn-info';

      /* comment placeholders so we can restore exact positions on mobile */
      var tPh = document.createComment('sdn-title');
      var pPh = document.createComment('sdn-price');
      if (title) title.parentNode.insertBefore(tPh, title);
      if (price) price.parentNode.insertBefore(pPh, price);

      function toDesktop() {
        if (title && title.parentElement !== info) info.appendChild(title);
        if (price && price.parentElement !== info) info.appendChild(price);
        if (info.parentElement !== grid) grid.appendChild(info);
      }
      function toMobile() {
        if (title && title.parentElement === info) tPh.parentNode.insertBefore(title, tPh);
        if (price && price.parentElement === info) pPh.parentNode.insertBefore(price, pPh);
        if (info.parentElement) info.remove();
      }
      function apply() { if (mql.matches) toDesktop(); else toMobile(); }

      if (mql.addEventListener) mql.addEventListener('change', apply);
      else if (mql.addListener) mql.addListener(apply);
      apply();
    });
  }

  /* Central init — runs once on load. */
  function init() {
    applyMotionPref();
    ensureGrain();
    initProductGallery(document);
    initProductAccordion(document);
    initProductInfoSplit(document);   /* title+price -> right column on >=1100; centred below */
    /* STEP 1 (card hover float) is pure CSS in sdn-effects.css. */
  }

  /* Re-run effects that target section markup when the Theme Editor
     re-renders a section (keeps live preview working). */
  function onSectionLoad(e) {
    var scope = e && e.target ? e.target : document;
    initProductGallery(scope);
    initProductAccordion(scope);
    initProductInfoSplit(scope);
  }

  if (reduceMQ.addEventListener) {
    reduceMQ.addEventListener('change', applyMotionPref);
  } else if (reduceMQ.addListener) {
    reduceMQ.addListener(applyMotionPref);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
})();
